import script from "./EventViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./EventViewer.vue?vue&type=script&setup=true&lang=js"

import "./EventViewer.vue?vue&type=style&index=0&id=618e4b1a&scoped=true&lang=css"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618e4b1a"]])

export default __exports__